module.exports = __webpack_public_path__ + "static/img/2.a974ea8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/3/zh/2.png
// module id = C0gM
// module chunks = 0